import React from "react";
import IndividualMilestone from "./individualMilestone";
import { Action } from "../../../constants/Common";

const EditMilestoneModule = (props) => {
  return (
    <div
      className="editDeliverable_height"
      style={{ height: "auto", maxHeight: "1200px" }}
    >
      {props?.milestones &&
        props?.milestones?.map((mL, index) => {
          return (
            <IndividualMilestone
              key={index}
              action={Action.UPDATE}
              eachMilestone={mL}
              eachMilestoneIndex={index}
            />
          );
        })}
    </div>
  );
};

export default EditMilestoneModule;
